<template>
  <div class="modal fade" id="import-choice-dialog" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('trail_import_dialog.import_choice_dialog.import_route') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="$t('shared.close')"></button>
        </div>
        <div class="modal-body">
          <p class="mb-3">{{ $t('trail_import_dialog.import_choice_dialog.how_would_you_like_to_import') }}</p>

          <div class="choice-options">
            <div class="choice-card" :class="{ selected: selectedChoice === 'reference' }" @click="selectedChoice = 'reference'">
              <div class="choice-icon">
                <span class="material-icons">link</span>
              </div>
              <h6>{{ $t('trail_import_dialog.import_choice_dialog.reference') }}</h6>
              <p class="small text-muted">{{ $t('trail_import_dialog.import_choice_dialog.any_edits_to_this_route_will') }}</p>
            </div>

            <div class="choice-card" :class="{ selected: selectedChoice === 'copy' }" @click="selectedChoice = 'copy'">
              <div class="choice-icon">
                <span class="material-icons">content_copy</span>
              </div>
              <h6>{{ $t('trail_import_dialog.import_choice_dialog.copy') }}</h6>
              <p class="small text-muted">{{ $t('trail_import_dialog.import_choice_dialog.create_an_independent_copy_that_can') }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('shared.cancel_2') }}</button>
          <button type="button" class="btn btn-primary" @click="confirm" :disabled="!selectedChoice">
            {{ $t('trail_import_dialog.import_choice_dialog.import_as_selected_choice', { selected_choice: selectedChoice === 'reference' ? 'Reference' : 'Copy' }) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      selectedChoice: null,
      route: null,
      callback: null
    };
  },
  methods: {
    show(route, callback) {
      this.route = route;
      this.callback = callback;
      this.selectedChoice = null;
    },
    confirm() {
      if (this.callback && this.selectedChoice) {
        this.callback(this.selectedChoice, this.route);
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.choice-options {
  display: flex;
  gap: 1rem;
}

.choice-card {
  flex: 1;
  padding: 1.5rem;
  border: 2px solid var(--gray);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;

  &:hover {
    border-color: #fddf00;
    background-color: var(--gray);
  }

  &.selected {
    border-color: #fddf00;
    background-color: var(--gray);
  }

  .choice-icon {
    margin-bottom: 0.5rem;

    .material-icons {
      font-size: 2rem;
      color: #fff;
    }
  }

  h6 {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  p {
    margin: 0;
  }
}
</style>
